(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-community-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__cwWallInit) return;
  window.__cwWallInit = true;

  // One pass of photos straight from the Liquid markup = the source of truth.
  function getSrc(wall) {
    if (wall.__src) return wall.__src;
    var imgs = [];
    wall.querySelectorAll('.cw-col-pass:not([aria-hidden]) img').forEach(function (im) { imgs.push(im.cloneNode(true)); });
    wall.__src = imgs;
    return imgs;
  }
  function colsFor(w, max) {
    if (w <= 600) return Math.min(2, max);
    if (w <= 1024) return Math.min(3, max);
    return max;
  }
  // Re-deal the photos into n real columns (round-robin), each duplicated for the seamless loop.
  function build(wall, n) {
    var src = getSrc(wall);
    if (!src.length) return;
    var base = parseInt(wall.dataset.cwSpeed, 10) || 70;
    var cols = [];
    for (var i = 0; i < n; i++) cols.push([]);
    src.forEach(function (im, idx) { cols[idx % n].push(im); });

    var frag = document.createDocumentFragment();
    cols.forEach(function (arr, ci) {
      var col = document.createElement('div');
      col.className = 'cw-col';
      col.style.setProperty('--col-dur', (base + ci * 8) + 's');
      var track = document.createElement('div');
      track.className = 'cw-col-track';
      for (var p = 0; p < 2; p++) {
        var pass = document.createElement('div');
        pass.className = 'cw-col-pass';
        if (p === 1) pass.setAttribute('aria-hidden', 'true');
        arr.forEach(function (im) { pass.appendChild(im.cloneNode(true)); });
        track.appendChild(pass);
      }
      col.appendChild(track);
      frag.appendChild(col);
    });
    wall.innerHTML = '';
    wall.appendChild(frag);
  }
  function apply(wall) {
    var max = parseInt(wall.dataset.cwCols, 10) || 4;
    var n = colsFor(window.innerWidth, max);
    if (wall.__n === n) return;
    wall.__n = n;
    build(wall, n);
  }
  function initAll(root) {
    (root || document).querySelectorAll('.wot-page .cw-wall').forEach(function (wall) { getSrc(wall); apply(wall); });
  }
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { document.querySelectorAll('.wot-page .cw-wall').forEach(apply); }, 200);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector) initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var scroller = root.querySelector('[data-insta-scroller]');
    var prev = root.querySelector('[data-insta-prev]');
    var next = root.querySelector('[data-insta-next]');
    var dots = root.querySelector('[data-insta-dots]');
    if (!scroller || !prev || !next || !dots) return;
    var cards = scroller.querySelectorAll('.insta-embed-wrap');
    var pageCount = 1, cardsPerPage = 1, pageWidth = 0;

    function measure() {
      if (!cards.length) return;
      var first = cards[0];
      var rect = first.getBoundingClientRect();
      var style = getComputedStyle(scroller);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var stride = rect.width + gap;
      var vw = scroller.clientWidth;
      cardsPerPage = Math.max(1, Math.floor((vw + gap) / stride));
      pageCount = Math.max(1, Math.ceil(cards.length / cardsPerPage));
      pageWidth = cardsPerPage * stride;
    }
    function buildDots() {
      dots.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var d = document.createElement('button');
        d.className = 'insta-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { go(idx); }); })(i);
        dots.appendChild(d);
      }
    }
    function curPage() { if (pageWidth === 0) return 0; return Math.round(scroller.scrollLeft / pageWidth); }
    function updateActive() {
      var a = curPage();
      dots.querySelectorAll('.insta-dot').forEach(function (d, i) { d.classList.toggle('active', i === a); });
      prev.disabled = a <= 0;
      next.disabled = a >= pageCount - 1;
    }
    function go(i) {
      var c = Math.max(0, Math.min(pageCount - 1, i));
      scroller.scrollTo({ left: c * pageWidth, behavior: 'smooth' });
    }
    function rebuild() { measure(); buildDots(); updateActive(); }

    prev.addEventListener('click', function () { go(curPage() - 1); });
    next.addEventListener('click', function () { go(curPage() + 1); });
    var raf;
    scroller.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
    });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(rebuild, 150);
    });
    rebuild();
  }
  function init() {
    document.querySelectorAll('.wot-page .feed-section').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-press-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__wotPressFlipInit) return;
  window.__wotPressFlipInit = true;

  var canHover = window.matchMedia('(hover: hover)').matches;

  function closeAll(stage) {
    stage.querySelectorAll('.pressflip-item.is-flipped').forEach(function (it) {
      it.classList.remove('is-flipped');
    });
  }
  function setup(stage) {
    if (stage.dataset.ready) return;
    stage.dataset.ready = '1';
    var m = stage.querySelector('.pressflip-marquee');
    if (canHover) {
      // Desktop: flip is pure CSS; just clone the strip for the seamless -50% loop.
      if (m && !m.dataset.duped) { m.dataset.duped = '1'; m.innerHTML = m.innerHTML + m.innerHTML; }
    } else {
      // Mobile: tap a card to flip it (one open at a time); the link still navigates.
      stage.addEventListener('click', function (e) {
        if (e.target.closest('.pressflip-link')) return;
        var item = e.target.closest('.pressflip-has-card');
        if (!item) { closeAll(stage); return; }
        var was = item.classList.contains('is-flipped');
        closeAll(stage);
        if (!was) item.classList.add('is-flipped');
      });
    }
  }
  function init() {
    document.querySelectorAll('.wot-page .pressflip-stage').forEach(setup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.wot-page .pressflip-stage').forEach(closeAll);
    });
    document.addEventListener('shopify:section:load', function (e) {
      var stage = e.target.querySelector ? e.target.querySelector('.pressflip-stage') : null;
      if (stage) setup(stage);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wot-page .press-marquee').forEach(function (m) {
      if (m.dataset.duped) return;
      m.dataset.duped = '1';
      m.innerHTML = m.innerHTML + m.innerHTML;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wot-page .reviews-track').forEach(function (track) {
      if (track.dataset.duped) return;
      track.dataset.duped = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-shop"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var track = root.querySelector('[data-shop-track]');
    var prev = root.querySelector('[data-shop-prev]');
    var next = root.querySelector('[data-shop-next]');
    var dots = root.querySelector('[data-shop-dots]');
    if (!track || !prev || !next || !dots) return;
    var cards = track.querySelectorAll('.product-card');
    if (!cards.length) return;
    var pageCount = 1, cardsPerPage = 1, pageWidth = 0;

    function measure() {
      var first = cards[0];
      var rect = first.getBoundingClientRect();
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      var stride = rect.width + gap;
      var vw = track.clientWidth;
      cardsPerPage = Math.max(1, Math.floor((vw + gap) / stride));
      pageCount = Math.max(1, Math.ceil(cards.length / cardsPerPage));
      pageWidth = cardsPerPage * stride;
    }
    function buildDots() {
      dots.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var d = document.createElement('button');
        d.className = 'shop-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { go(idx); }); })(i);
        dots.appendChild(d);
      }
    }
    function curPage() { if (pageWidth === 0) return 0; return Math.round(track.scrollLeft / pageWidth); }
    function updateActive() {
      var a = curPage();
      dots.querySelectorAll('.shop-dot').forEach(function (d, i) { d.classList.toggle('active', i === a); });
      prev.disabled = a <= 0;
      next.disabled = a >= pageCount - 1;
    }
    function go(i) {
      var c = Math.max(0, Math.min(pageCount - 1, i));
      track.scrollTo({ left: c * pageWidth, behavior: 'smooth' });
    }
    function rebuild() { measure(); buildDots(); updateActive(); }
    prev.addEventListener('click', function () { go(curPage() - 1); });
    next.addEventListener('click', function () { go(curPage() + 1); });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateActive);
    });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(rebuild, 150);
    });
    rebuild();
  }
  function init() {
    document.querySelectorAll('.wot-page .product-carousel-wrap').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wot-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wot-page .spotlight-section').forEach(function (root) {
      var carousel = root.querySelector('[data-celeb-carousel]');
      var prev = root.querySelector('[data-celeb-prev]');
      var next = root.querySelector('[data-celeb-next]');
      if (!carousel || !prev || !next) return;
      var cards = carousel.querySelectorAll('.celeb-card');
      if (!cards.length) return;
      var idx = 0;
      function show(i) {
        cards.forEach(function (c) {
          c.classList.remove('active');
          var v = c.querySelector('video');
          if (v) v.pause();
        });
        idx = i;
        cards[idx].classList.add('active');
        var activeVideo = cards[idx].querySelector('video');
        if (activeVideo) activeVideo.play();
        prev.disabled = idx <= 0;
        next.disabled = idx >= cards.length - 1;
      }
      prev.addEventListener('click', function () { if (idx > 0) show(idx - 1); });
      next.addEventListener('click', function () { if (idx < cards.length - 1) show(idx + 1); });
      show(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
